export const CARD=['MASTERCARD','MASTERCARD-USD','AMEX','AMEX-USD', 'CYBERSOURCE', 'CYBERSOURCE-USD', 'NTB-AMEX-LKR','NTB-AMEX-USD','MASTERCARD-FUNDING']
export const SAMPATH = ['SAMPATH-VISHWA']
export const LQR = ['LQR']
export const FRIMI = ['FRIMI']
export const HELAPAY = ['HELAPAY']
export const QPLUS = ['Q-PLUS']